export const iotaGenerator = fn => {

    const currentIota = iotaDefault();

    if (angular.isFunction(fn)) {

        return () => fn(currentIota());
    }

    return currentIota;

    function iotaDefault() {

        let current = 0;
        let next = 0;

        return () => {

            current = next;

            next += 1;

            return current;
        };
    }
};



// WEBPACK FOOTER //
// ./src/helpers/iota.js